"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.privateLeasingFields = exports.businessLeasingFields = void 0;
exports.businessLeasingFields = `
  administrationFee
  extraFeeMonthly
  ignoreCampaigns
  invoiceFee
  minimumAdministrationFee
  minimumNominalInterest
  monthlyCostServices
  nominalInterest
  residualValue
  serviceAgreementPerYearFee
  subsidyCampaign
  tireHotelPerYearFee
  totalCost
  totalMonthlyCost
  totalMonthlyCostIncludingServices
`;
exports.privateLeasingFields = `
  annualCost
  ${exports.businessLeasingFields}
`;
//# sourceMappingURL=leasing.js.map